const START_COUNT = 3;
const LOAD_MORE_COUNT = 6;

document.querySelectorAll('.js-picture-series').forEach(init);

function init(element) {
	const startCount = Number.parseInt(element.dataset.startCount) || START_COUNT;
	const loadMoreCount =
		Number.parseInt(element.dataset.loadMoreCount) || LOAD_MORE_COUNT;
	const loadMoreButton = document.getElementById(element.dataset.loadMore);
	const images = Array.from(element.querySelectorAll('.picture-series__image'));
	if (loadMoreButton) {
		if (images.length <= startCount) {
			loadMoreButton.classList.add('hidden'); // fix that class name…
		} else {
			for (const item of images.slice(startCount)) {
				item.classList.add('picture-series__image--hidden');
			}
		}
		loadMoreButton.addEventListener('click', () => {
			const hiddenImageCount = images.filter((image) =>
				image.matches('.picture-series__image--hidden'),
			).length;
			const firstHidden = images.length - hiddenImageCount;
			for (const item of images.slice(
				firstHidden,
				firstHidden + loadMoreCount,
			)) {
				item.classList.remove('picture-series__image--hidden');
			}
			if (hiddenImageCount <= loadMoreCount) {
				loadMoreButton.classList.add('hidden');
			}
		});
	}
}
